import { toast, ToastOptions, ToastPosition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type ToastType = 'info' | 'success' | 'warning' | 'error';

interface AppSnackbarOptions {
  type: ToastType;
  message: string;
}

export const AppSnackbar = ({ type, message }: AppSnackbarOptions) => {
  const options: ToastOptions = {
    position: 'top-right' as ToastPosition,
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  };

  switch (type) {
    case 'info':
      toast.info(message, options);
      break;
    case 'success':
      toast.success(message, options);
      break;
    case 'warning':
      toast.warning(message, options);
      break;
    case 'error':
      toast.error(message, options);
      break;
    default:
      // this is default
      break;
  }
};
